import { useState } from "react"
import { ISubContext } from "../../context/types"
import { initApi } from "./api"
import { SearchApi, SearchState } from "./types"

export const useSearchSubcontext = (): ISubContext<SearchState, SearchApi> => {

  const [state_, setState_] = useState(new SearchState())

  return {
    state: state_,
    api: initApi(state_, setState_),
  }
}
